import { render, staticRenderFns } from "./DocRequestList.vue?vue&type=template&id=d3ac61fa&scoped=true&"
import script from "./DocRequestList.vue?vue&type=script&lang=js&"
export * from "./DocRequestList.vue?vue&type=script&lang=js&"
import style0 from "./DocRequestList.vue?vue&type=style&index=0&id=d3ac61fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ac61fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
